// extracted by mini-css-extract-plugin
export default {"container":"Avatars_container__QmY1o","additionalUsers":"Avatars_additionalUsers__kxDXu"};